// src/Home.js
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import PaymentProviderApi from './AxiosConfig';
import Spinner from './spinner'; // Assume you have a Spinner component or a gif for loading
import log from './logger';

function PaymentComplete() {
    const [searchParams] = useSearchParams();
    const [canCloseWindow, setCanCloseWindow] = useState(false);
    const [closeWindowMessage, setCloseWindowMessage] = useState("You can now close this window");
    var loopCount = 0;

    useEffect(() => {
        const checkPaymentTransactionStatus = async (transaction_id, intervalId) => {
            try {
                log.info(`Check payment transaction status for:${transaction_id}`);
                console.log(`Check payment transaction status for:${transaction_id}`);
                const response = await PaymentProviderApi.get(`/transactions/transaction_status?transaction_id=${transaction_id}`);
                if (response && response.data) {
                    log.info(`Payment Transaction status: ${response.data.paymentStatus}`);
                    console.log(`Payment Transaction status: ${response.data.paymentStatus}`);
                    if (response.data.paymentStatus === "PAID") {
                        clearInterval(intervalId); // Stop the timer
                        setCloseWindowMessage("Payment successful");
                        setCanCloseWindow(true);
                        window.location.href = 'com.app.healthblocks://everest.healthblocks.ai/paymentcomplete';
                        window.close();
                    }
                    else if (response.data.paymentStatus === "CANCELLED" || response.data.paymentStatus === "EXPIRED") {
                        //User Cancelled or dropped out of payment
                        setCloseWindowMessage("Payment cancelled");
                        setCanCloseWindow(true);
                        clearInterval(intervalId); // Stop the timer
                        window.location.href = 'com.app.healthblocks://everest.healthblocks.ai/paymentfailed';
                        window.close();
                    }
                    else if (response.data.paymentStatus === "FAILED") {
                        //Payment Failed
                        clearInterval(intervalId); // Stop the timer
                        setCloseWindowMessage("Payment Failed");
                        setCanCloseWindow(true);
                        window.location.href = 'com.app.healthblocks://everest.healthblocks.ai/paymentfailed';
                        window.close();
                    }
                }
            } catch (err) {
                clearInterval(intervalId); // Stop the timer on error
                log.error(`Unexpected error checking transaction status ${transaction_id} - ${err}`);
                console.error(`Unexpected error checking transaction status ${transaction_id} - ${err}`);
                setCloseWindowMessage("Unexpected payment error");
                setCanCloseWindow(true);
                window.location.href = 'com.app.healthblocks://everest.healthblocks.ai/paymentfailed';
                window.close();
            }
        };

        const transaction_id = searchParams.get('transaction_id');
        if (transaction_id) {
            const intervalId = setInterval(() => {
                if (loopCount++ === 30) {
                    //Looped through 30 times. Time to end
                    log.error(`Transaction status check for ${transaction_id} took too long - returning to app`);
                    console.error(`Transaction status check for ${transaction_id} took too long - returning to app`);
                    setCloseWindowMessage("Payment Service Took Too Long");
                    setCanCloseWindow(true);
                    window.location.href = 'com.app.healthblocks://everest.healthblocks.ai/paymentfailed';
                    window.close();
                }
                checkPaymentTransactionStatus(transaction_id, intervalId);
            }, 2000);

            return () => clearInterval(intervalId); // Clean up the interval on component unmount
        }
        else {
            log.error(`No transaction id supplied - returning to app`);
            console.error(`No transaction id supplied - returning to app`);
            setCloseWindowMessage("I cannot determine the payment status");
            setCanCloseWindow(true);
            window.location.href = 'com.app.healthblocks://everest.healthblocks.ai/paymentfailed';
            window.close();
        }
    }
        , [searchParams]);

    return (
        <div className="bg-gradient-to-r from-black via-black to-black h-screen flex justify-center items-center text-white">
            <div className="flex flex-col justify-center items-center">
                {
                    canCloseWindow
                        ?
                        <section className='text-center'>
                            <p className="mt-4 text-xl font-bold">{closeWindowMessage}</p>
                            <p className="mt-4 text-sm font-bold">You can now close this browser window</p>
                        </section>
                        :
                        <section>
                            <Spinner />
                            <p className="mt-4 text-xl font-bold">Please wait...</p>
                        </section>
                }
            </div>
        </div>
    );
}

export default PaymentComplete;
